// libraries
import React, { useState } from "react";
import { toast } from "react-toastify";

// components
import Input from "./Input/Input";
import Radio from "./Radio/Radio";
import Button from "./Button/Button";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

// utils
import { registerUser } from "src/utils/requests/register_screen/login";

// assets
import ThreeDots from "src/assets/icons/three-dots.svg";

// animation
import FadeTop from "src/components/Animation/FadeTop";

const RegisterForm = ({ changeForm }) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    checked: false,
    contact: "",
    country: "",
    state: "",
    city: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      formData.name === "" ||
      formData.email === "" ||
      formData.password === ""
    ) {
      toast.info("Please filled out the required fields");
      return;
    }

    if (!formData.checked) {
      toast.info("check terms & condition");
      return;
    }

    setLoading(true);
    registerUser(formData)
      .then((res) => {
        if (res.data.Status) {
          toast.success(res.data.Results);
          changeForm(1);
          setLoading(false);
        } else {
          toast.error(res.data.ErrorMessage);
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  };

  return (
    <form>
      <FadeTop duration={0.3}>
        <Header icon handleChange={() => changeForm(1)} />
        <Input
          label="Full Name"
          placeholder="Write your full name"
          type="text"
          value={formData.name || ""}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <Input
          label="Email"
          placeholder="Write your email"
          type="email"
          value={formData.email || ""}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <Input
          label="Password"
          placeholder="Use 8 character password"
          type="password"
          icon="true"
          value={formData.password || ""}
          onChange={(e) =>
            setFormData({ ...formData, password: e.target.value })
          }
        />
        <Radio
          checked={formData.checked || false}
          onChange={() =>
            setFormData({ ...formData, checked: !formData.checked })
          }
        />
        <div className="sm-space-38"></div>
        <Button
          label="Create Account"
          fill
          handleClick={handleSubmit}
          isLoading={loading}
        />
        <div className="sm-space-80"></div>
        <Footer
          label="Already have an account?"
          btnLabel="log in"
          text={`By clicking “Login” i agree to Event Moon Terms and Privacy. \n 
        i confirm that i am at least 13 years old.`}
          handleChange={() => changeForm(1)}
        />
      </FadeTop>
    </form>
  );
};

export default RegisterForm;
